import { useLayoutEffect, useEffect } from 'react';
import IS_BROWSER from '../isBrowser/index.js';

var useIsomorphicLayoutEffect = IS_BROWSER ? useLayoutEffect : useEffect;

export { useIsomorphicLayoutEffect as default };
//# sourceMappingURL=index.js.map
